import { useEffect, useState } from "react";
import depositService from "../api/deposit.api";
import { DepositFlow } from "../models/constants";
import userDeviceStore from "../../../store/device.store";
import { useAppDispatch } from "../../../store/hooks";
import { changeLoaderState } from "../../../reducers/appStateReducer";


import DepositV1 from "./DepositV1";
import DepositV2 from "./DepositV2";
import errorModal from "../../../services/errorModal.service";

export function Deposit() {
  const [flowValue, setFlowValue] = useState<string | null>(null);
  const dispatch = useAppDispatch();
  const deviceType = userDeviceStore((state) => state.deviceType);

  useEffect(() => {
    getDepositFlowDetails();
  }, []);

  const getDepositFlowDetails = async () => {
    dispatch(changeLoaderState(true));
    const response = await depositService.getDepositFlowDetails();
    if (!response.isSuccess) {
      errorModal.showErrorModal(response.statusCode, response.message);
    }
    if (response.isSuccess && response.data) {
      setFlowValue(response.data.value);
      dispatch(changeLoaderState(false));
    }
  };

  let content = (
    <div>
      {flowValue && (flowValue === DepositFlow.OldFlow ? (
        <DepositV1 depositFlow={flowValue} deviceType={deviceType} />
      ) : (
        <DepositV2 depositFlow={flowValue} deviceType={deviceType} />
      ))}
    </div>
  );

  return content;
}
